// extracted by mini-css-extract-plugin
export default {"valid":"globalStyles_valid__m7U8J","invalid":"globalStyles_invalid__OYhkP"};